import { useState } from "react";
import { IconQueue } from "@/components/ui/icons";
import { Modal } from "@/components/ui/Modal";
import { usePlayer } from "@/hooks/usePlayer";

export function QueueDrawer() {
  const [open, setOpen] = useState(false);
  const { queue, index } = usePlayer();
  return (
    <>
      <button title="File d'attente" onClick={() => setOpen(true)}><IconQueue /></button>
      <Modal open={open} onClose={() => setOpen(false)} title={`File d'attente (${queue.length})`}>
        <ol style={{ margin: 0, padding: 0, listStyle: "none", maxHeight: "60vh", overflow: "auto" }}>
          {queue.map((t, i) => (
            <li key={t.id + i} style={{
              padding: "8px 10px", borderRadius: 8,
              background: i === index ? "var(--accent-soft)" : "transparent",
            }}>
              <div className="trunc" style={{ fontWeight: i === index ? 700 : 500 }}>{t.title}</div>
              <div className="muted trunc">{t.artist.name}</div>
            </li>
          ))}
        </ol>
      </Modal>
    </>
  );
}
